import React from 'react';
import { SunIcon, MoonIcon, ComputerDesktopIcon } from '@heroicons/react/24/outline';
import { useTheme } from '../../context/ThemeContext';

const ThemeToggle = ({ variant = "button" }) => {
  const { theme, setTheme } = useTheme();

  const themes = [
    { value: "light", label: "Light", icon: SunIcon },
    { value: "dark", label: "Dark", icon: MoonIcon },
    { value: "system", label: "System", icon: ComputerDesktopIcon },
  ];

  const currentTheme = themes.find(t => t.value === theme) || themes[2];

  if (variant === "dropdown") {
    return (
      <div className="relative group">
        <button className="flex items-center space-x-2 px-3 py-2 text-sm rounded-md hover:bg-accent hover:text-accent-foreground transition-colors">
          <currentTheme.icon className="h-4 w-4" />
          <span>{currentTheme.label}</span>
        </button>
        
        <div className="absolute right-0 mt-1 w-32 bg-popover border border-border rounded-md shadow-lg z-50 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all">
          <div className="p-1">
            {themes.map((themeOption) => {
              const Icon = themeOption.icon;
              return (
                <button
                  key={themeOption.value}
                  onClick={() => setTheme(themeOption.value)}
                  className={`w-full flex items-center space-x-2 px-3 py-2 text-sm rounded-sm transition-colors ${
                    theme === themeOption.value 
                      ? 'bg-accent text-accent-foreground' 
                      : 'hover:bg-accent hover:text-accent-foreground'
                  }`}
                >
                  <Icon className="h-4 w-4" />
                  <span>{themeOption.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  const nextTheme = () => {
    const currentIndex = themes.findIndex(t => t.value === theme);
    const nextIndex = (currentIndex + 1) % themes.length;
    setTheme(themes[nextIndex].value);
  };

  return (
    <button
      onClick={nextTheme}
      className="p-2 rounded-md hover:bg-accent hover:text-accent-foreground transition-colors focus:outline-none focus:ring-2 focus:ring-ring"
      title={`Current theme: ${currentTheme.label}. Click to switch.`}
    >
      <currentTheme.icon className="h-5 w-5" />
    </button>
  );
};

export default ThemeToggle;